"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _publish = _interopRequireDefault(require("../../../../../services/events/publish"));
const usePublishLoginAbandoned = () => {
  return (0, _react.useCallback)(function (reason) {
    let client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "web";
    (0, _publish.default)({
      module: "account",
      category: "authentication",
      action: "login abandoned",
      event_name: "account: authentication: login abandoned",
      props: {
        client,
        reason
      }
    });
  }, []);
};
var _default = exports.default = usePublishLoginAbandoned;